import axios from "axios";
import * as Preferences from "./Preferences";

export const CreateNewPartialPayoutRequest = (
  terminalGUID,
  amount,
  callback
) => {
  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PARTIAL_PAYOUT_HANDLER_INSERT_NEW;

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      userSessionID: amount
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const SelectPayoutRequest = (receiptNumber, securityCode, callback) => {
  console.log("IN SELECT REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL + Preferences.PARTIAL_PAYOUT_HANDLER_SELECT;

  //zovi axios
  axios
    .post(svcUrl, {
      receiptNumber: receiptNumber,
      securityCode: securityCode
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const PayoutToUserSession = (
  terminalGUID,
  receiptNumber,
  securityCode,
  callback
) => {
  console.log("IN SELECT REQUEST...");

  let svcUrl =
    Preferences.LOCALHOST_BASE_URL +
    Preferences.PARTIAL_PAYOUT_HANDLER_PAYOUT_TO_USER_SESSION;

  //zovi axios
  axios
    .post(svcUrl, {
      terminalGUID: terminalGUID,
      ticketNumber: receiptNumber,
      securityCode: securityCode
    })
    .then(response => {
      console.log("Received response! ", response);
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};



// WEBPACK FOOTER //
// ./src/Communication/PartialPayoutServicesHandler.js